import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import humanFormat from 'human-format';
import Diff from '../../common/diff';

const Main = styled.div`
  color: white;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
`;

const Value = styled.span`
  font: ${props => props.theme.fontWeightBold} 19px/20px ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
`;

const readble = d => humanFormat(d, { decimals: 1, separator: '' });

export default function FollowersChangedTooltip({ payload }) {
  const [{ payload: { value, changed } }] = payload;

  return (
    <Main>
      <Value>{readble(value)}</Value>
      {!!changed && <Diff value={changed} />}
    </Main>

  );
}

FollowersChangedTooltip.propTypes = {
  payload: PropTypes.arrayOf(PropTypes.shape({
    payload: PropTypes.shape({
      value: PropTypes.number.isRequired,
      changed: PropTypes.number.isRequired,
    }).isRequired,
  })).isRequired,
};
